module.exports = __webpack_public_path__ + "img/star.787e9de7.png";